import { GroupService } from '../../api';
import { DefaultQueryKeyFactory, QueryKeyFactoryGenerator } from '../../utils/query-keys-factory';

export const groupQueryKeys = new QueryKeyFactoryGenerator<DefaultQueryKeyFactory>('group')
  .includeList<string, typeof GroupService.groupList>()
  .getFactory();
